import { api as hyperbeamApi } from './auto-generated/hyperbeam'
import { api as eventApi } from './auto-generated/event'

hyperbeamApi.enhanceEndpoints({
  endpoints: {
    hyperbeamStartHyperbeamVm: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        dispatch(
          eventApi.util.updateQueryData('eventGetEventById', args, (draftEvent) => {
            draftEvent.event_type = 'HYPERBEAM'
          }),
        )
        dispatch(
          eventApi.util.updateQueryData('eventGetCurrentEvent', undefined, (draftEvent) => {
            draftEvent.event_type = 'HYPERBEAM'
          }),
        )
        try {
          await queryFulfilled
        } catch {}
      },
    },
  },
})

export { hyperbeamApi }
